import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
import { useAutocomplete } from "../../hooks";
import { getMethodsForTestId } from "../../utils/getMethodsForTestId";
export function useField(_ref) {
  var onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      namespace = _ref.namespace,
      componentName = _ref.componentName,
      ref = _ref.ref;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useAutocomplete = useAutocomplete(ref === null || ref === void 0 ? void 0 : ref.current),
      isAutofill = _useAutocomplete.isAutofill;

  var _getMethodsForTestId = getMethodsForTestId(namespace, componentName || undefined),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  var handleFocus = useCallback(function (e) {
    if (onFocus) {
      onFocus(e);
    }

    setFocused(true);
  }, [onFocus]);
  var handleBlur = useCallback(function (e) {
    if (onBlur) {
      onBlur(e);
    }

    setFocused(false);
  }, [onBlur]);
  return {
    focused: focused,
    handleFocus: handleFocus,
    handleBlur: handleBlur,
    getTestId: getTestId,
    getNamespace: getNamespace,
    isAutofill: isAutofill
  };
}